import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  root: {},
}));

export default useStyles;
